export default "__VITE_ASSET__D5Uv1OiR__"